import AdditionalQuestionsFormContainer from './additional_questions_form_container';

const AdditionalQuestionsForm = AdditionalQuestionsFormContainer;
export default AdditionalQuestionsForm;
